var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 128,
    height: 128,
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.983 113.273C58.7708 113.273 53.4375 111.364 48.983 107.545C44.5284 103.727 41.1042 98.2576 38.7102 91.1364C36.3466 83.9848 35.1648 75.4242 35.1648 65.4545C35.1648 55.5151 36.3617 46.9697 38.7557 39.8182C41.1496 32.6667 44.5587 27.1818 48.983 23.3636C53.4375 19.5455 58.7708 17.6364 64.983 17.6364C71.1951 17.6364 76.5133 19.5455 80.9375 23.3636C85.392 27.1818 88.8163 32.6667 91.2102 39.8182C93.6042 46.9697 94.8011 55.5151 94.8011 65.4545C94.8011 75.4242 93.6042 83.9848 91.2102 91.1364C88.8466 98.2576 85.4375 103.727 80.983 107.545C76.5284 111.364 71.1951 113.273 64.983 113.273ZM64.983 108C72.5284 108 78.4527 104.258 82.7557 96.7727C87.0587 89.2576 89.2102 78.8182 89.2102 65.4545C89.2102 56.5455 88.2254 48.9091 86.2557 42.5455C84.3163 36.1818 81.5436 31.3182 77.9375 27.9545C74.3314 24.5606 70.0133 22.8636 64.983 22.8636C57.4375 22.8636 51.5133 26.6212 47.2102 34.1364C42.9072 41.6515 40.7557 52.0909 40.7557 65.4545C40.7557 74.3636 41.7254 82 43.6648 88.3636C45.6042 94.697 48.3769 99.5606 51.983 102.955C55.6193 106.318 59.9527 108 64.983 108Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutput);
export default __webpack_public_path__ + "static/media/output.73d366be2343a4b1849120abed9cd1c3.svg";
export { ForwardRef as ReactComponent };